import { Fragment } from 'react';

export default function ConfirmDialog({ open, title = 'Confirm', message = '', confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false, onConfirm, onClose }) {
  if (!open) return null;

  return (
    <Fragment>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
        <div className="w-full max-w-md rounded-xl bg-dark-800 p-6 shadow-xl">
          <h3 className="text-lg font-semibold text-dark-100">{title}</h3>
          {message && <p className="mt-2 text-sm text-dark-300">{message}</p>}
          <div className="mt-6 flex justify-end gap-3">
            <button onClick={onClose} className="btn btn-secondary">
              {cancelLabel}
            </button>
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className={danger ? 'btn btn-error' : 'btn btn-primary'}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
